import type { CeoDebtScheduleItem } from '@shared/api';
import { Badge } from '@shared/ui/Badge';
import { formatDateRu } from '../ceoFormat';
import { paymentNote, rowBadges } from './scheduleModel';
import { BadgeRow, PaymentNoteText } from './styles';

/**
 * Статус строки графика — в календаре «К оплате» и в карточке договора одинаково:
 * бейджи, дата оплаты и документ. Без документа — «основание не указано»: подтверждения
 * выпиской у такой отметки нет.
 */
export function ScheduleStatus({ item }: { item: CeoDebtScheduleItem }) {
  const note = paymentNote(item);
  return (
    <>
      <BadgeRow>
        {rowBadges(item).map((b) => (
          <Badge key={b.label} $tone={b.tone}>
            {b.label}
          </Badge>
        ))}
      </BadgeRow>
      {note && (
        <PaymentNoteText>
          {item.paid_date ? `${formatDateRu(item.paid_date)} · ` : ''}
          {note}
        </PaymentNoteText>
      )}
    </>
  );
}
